import { Stack } from '@mui/material'
import { BerthPlanningViewStore } from '@planning/pages/BerthPlanning/Stores/BerthPlanningViewStore'
import { VesselVisitPlanningStore } from '@planning/rt-stores/vesselVisit/VesselVisitPlanningStore'
import { useRegisterSubFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { VesselVisitBerthAndTimingFormStore } from '../../Stores/VesselVisitBerthAndTimingFormStore'
import { VesselVisitCargoFormStore } from '../../Stores/VesselVisitCargoFormStore'
import { VesselVisitFormStore } from '../../Stores/VesselVisitFormStore'
import { VesselVisitGeneralInformationFormStore } from '../../Stores/VesselVisitGeneralInformationFormStore'
import { VesselVisitBerthAndTimingControlCard } from '../organisms/BerthAndTimings/VesselVisitBerthAndTimingControlCard'
import { VesselVisitCargoControlCard } from '../organisms/Cargo/VesselVisitCargoControlCard'
import { VesselVisitGeneralInformationControlCard } from '../organisms/GeneralInformation/VesselVisitGeneralInformationControlCard'
import { VesselVisitNotesControlCard } from '../organisms/Notes/VesselVisitNotesControlCard'

type VesselVisitPlanningFormProps = {
  formStore: VesselVisitFormStore
  berthPlanningViewStore: BerthPlanningViewStore
  // todo: will be removed in future
  vesselVisitPlanningStore: VesselVisitPlanningStore
}

export const VesselVisitPlanningForm2: FC<VesselVisitPlanningFormProps> = observer(props => {
  const { formStore, berthPlanningViewStore } = props
  const { generalInformation, cargo, berthAndTiming } = formStore.initialValues

  const vesselVisitGeneralInformationFormStore = useRegisterSubFormStore(
    formStore,
    'generalInformation',
    new VesselVisitGeneralInformationFormStore(generalInformation),
  )

  const vesselVisitCargoFormStore = useRegisterSubFormStore(
    formStore,
    'cargo',
    new VesselVisitCargoFormStore(cargo),
  )

  const vesselVisitBerthAndTimingFormStore = useRegisterSubFormStore(
    formStore,
    'berthAndTiming',
    new VesselVisitBerthAndTimingFormStore(berthPlanningViewStore.berthItemStore, berthAndTiming),
  )

  berthPlanningViewStore.setVesselVisitBerthAndTimingFormStore(vesselVisitBerthAndTimingFormStore)

  const isEditMode = !!formStore.id

  return (
    <form autoComplete='off'>
      <Stack gap={2}>
        <VesselVisitGeneralInformationControlCard
          vesselVisitGeneralInformationFormStore={vesselVisitGeneralInformationFormStore}
          isEditMode={isEditMode}
          berthPlanningViewStore={berthPlanningViewStore}
        />
        <VesselVisitCargoControlCard
          vesselVisitCargoFormStore={vesselVisitCargoFormStore}
          vesselType={vesselVisitGeneralInformationFormStore.data.vessel?.vesselType}
          isEditMode={isEditMode}
        />
        <VesselVisitBerthAndTimingControlCard
          isEditMode={isEditMode}
          berthPlanningViewStore={berthPlanningViewStore}
          vesselVisitBerthAndTimingFormStore={vesselVisitBerthAndTimingFormStore}
          allowEdit
        />
        <VesselVisitNotesControlCard isEditMode={isEditMode} formStore={formStore} allowEdit />
      </Stack>
    </form>
  )
})
